document.querySelectorAll('[data-featured]').forEach(section=>{const tabs=[...section.querySelectorAll('[role="tab"]')];const activate=tab=>{tabs.forEach(item=>{const active=item===tab;item.setAttribute('aria-selected',String(active));item.tabIndex=active?0:-1;document.getElementById(item.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',event=>{let target;if(event.key==='ArrowRight')target=tabs[(index+1)%tabs.length];if(event.key==='ArrowLeft')target=tabs[(index-1+tabs.length)%tabs.length];if(target){event.preventDefault();activate(target);target.focus();}});});});document.querySelectorAll('[data-product]').forEach(section=>{
 const prompt=section.querySelector('[data-size-prompt]');
 const showPrompt=input=>{if(prompt)prompt.hidden=!input.checked||input.dataset.available!=='true';};
 section.querySelectorAll('[data-variant]').forEach(input=>input.addEventListener('click',()=>showPrompt(input)));
 section.querySelectorAll('[data-variant]').forEach(input=>input.addEventListener('change',()=>{
  if(!input.checked)return;
  showPrompt(input);
  section.querySelector('[data-price]').textContent=input.dataset.price;
  const button=section.querySelector('[data-add]');
  button.disabled=input.dataset.available!=='true';
  const buyNow=section.querySelector('[data-buy-now]');
  if(buyNow)buyNow.disabled=button.disabled;
  button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;
  const url=new URL(location.href);
  url.searchParams.set('variant',input.value);
  history.replaceState({},'',url);
 }));
});
const navMenus = [...document.querySelectorAll('.vx-header .vx-menu')];
navMenus.forEach(menu => menu.addEventListener('toggle', () => { if(menu.open) navMenus.forEach(other => {if(other !== menu) other.open = false;}); }));
document.addEventListener('click', event => { if(!event.target.closest('.vx-header')) navMenus.forEach(menu => {menu.open = false;}); });
document.addEventListener('keydown', event => { if(event.key === 'Escape') navMenus.forEach(menu => {if(menu.open){menu.open = false;menu.querySelector('summary').focus();}}); });

document.querySelectorAll('.vx-model-switcher a').forEach(link=>link.addEventListener('click',()=>{link.closest('.vx-model-switcher').open=false;}));

document.querySelectorAll('[data-product]').forEach(section=>{
 const sync=()=>{
  const selected=section.querySelector('[data-variant]:checked');
  if(!selected)return;
  section.querySelector('[data-sticky-price]').textContent=selected.dataset.price;
  const size=section.querySelector('[data-sticky-size]');
  size.textContent=size.dataset.prefix+' '+selected.dataset.title;
  section.querySelector('[data-sticky-buy]').disabled=selected.dataset.available!=='true';
  const compare=section.querySelector('[data-compare-price]');
  if(compare){compare.textContent=selected.dataset.compare;compare.hidden=!selected.dataset.compare;}
 };
 const size=section.querySelector('[data-sticky-size]');
 if(size){size.dataset.prefix=size.textContent.split(':')[0]+':';section.querySelectorAll('[data-variant]').forEach(input=>input.addEventListener('change',sync));sync();}
});

document.querySelectorAll('[data-gallery]').forEach(gallery=>{
 const thumbnails=[...gallery.querySelectorAll('[data-gallery-thumbnail]')];
 const panels=[...gallery.querySelectorAll('[data-gallery-panel]')];
 const activate=button=>{
  const target=button.getAttribute('aria-controls');
  panels.forEach(panel=>{panel.hidden=panel.id!==target;});
  thumbnails.forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 };
 thumbnails.forEach((button,index)=>{
  button.addEventListener('click',()=>activate(button));
  button.addEventListener('keydown',event=>{
   let next;
   if(event.key==='ArrowRight')next=thumbnails[(index+1)%thumbnails.length];
   if(event.key==='ArrowLeft')next=thumbnails[(index-1+thumbnails.length)%thumbnails.length];
   if(event.key==='Home')next=thumbnails[0];
   if(event.key==='End')next=thumbnails[thumbnails.length-1];
   if(next){event.preventDefault();activate(next);next.focus();}
  });
 });
});
